import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const STORAGE_KEY = 'site-storage'

const initialState = {
  currentSite: null,
  hasExplicitBrandIntent: false,
  _hasHydrated: false,
  isCheckInEnabled: false,
}

const useSiteStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      setCurrentSite: (site) => {
        set({ currentSite: site, hasExplicitBrandIntent: false })
      },

      clearCurrentSite: () => {
        set({ currentSite: null })
      },

      clearCurrentSiteWithBrandIntent: () => {
        set({ currentSite: null, hasExplicitBrandIntent: true })
      },

      clearBrandIntent: () => {
        set({ hasExplicitBrandIntent: false })
      },

      setIsCheckInEnabled: (value) => {
        if (get().isCheckInEnabled !== value) {
          set({ isCheckInEnabled: value })
        }
      },

      getCurrentSiteId: () => {
        return get().currentSite?.siteId || null
      },

      getCurrentSiteName: () => {
        return get().currentSite?.name || null
      },

      hasCurrentSite: () => {
        return !!get().currentSite
      },

      // Reset store to initial state and clear persisted storage
      reset: () => {
        try {
          localStorage.removeItem(STORAGE_KEY)
        } catch (error) {
          console.warn('Failed to clear site storage:', error)
        }
        // Keep _hasHydrated: true since the store is already hydrated
        // Only reset the data, not the hydration flag
        set({
          currentSite: null,
          hasExplicitBrandIntent: false,
          _hasHydrated: true,
        })
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        currentSite: state.currentSite,
        hasExplicitBrandIntent: state.hasExplicitBrandIntent,
      }),
      onRehydrateStorage: () => {
        return (state) => {
          if (state) {
            state._hasHydrated = true
          }
        }
      },
    }
  )
)

export default useSiteStore
